module.exports = __webpack_public_path__ + "img/3.98fa7d90.jpg";